import type { MissingTranslationKeyReport } from "@next-platform/client-common-core";

type TrackJsLike = {
  track: (error: Error) => void;
  console: { warn: (...args: unknown[]) => void };
};

const MAX_PENDING_MISSING_KEY_REPORTS = 50;

let trackJsClient: TrackJsLike | null = null;
const pendingMissingKeyReports: MissingTranslationKeyReport[] = [];

const sendMissingTranslationKeyReport = (report: MissingTranslationKeyReport): void => {
  const client = trackJsClient;
  if (!client) return;

  try {
    client.console.warn("missing_translation_key context", report);
    client.track(new Error(`missing_translation_key: ${report.namespace}:${report.key}`));
  } catch {
    // Per-report track failure is non-fatal; continue draining the queue.
  }
};

const enqueuePendingMissingKeyReport = (report: MissingTranslationKeyReport): void => {
  if (pendingMissingKeyReports.length >= MAX_PENDING_MISSING_KEY_REPORTS) {
    pendingMissingKeyReports.shift();
  }
  pendingMissingKeyReports.push(report);
};

const flushPendingMissingKeyReports = (): void => {
  while (pendingMissingKeyReports.length > 0) {
    const report = pendingMissingKeyReports.shift();
    if (report) {
      sendMissingTranslationKeyReport(report);
    }
  }
};

export const registerTrackJsForMissingTranslationKeys = ({ trackJs }: { trackJs: TrackJsLike }): void => {
  trackJsClient = trackJs;
  flushPendingMissingKeyReports();
};

const reportMissingTranslationKeyToTrackJs = (report: MissingTranslationKeyReport): void => {
  if (!trackJsClient) {
    enqueuePendingMissingKeyReport(report);
    return;
  }

  sendMissingTranslationKeyReport(report);
};

export default reportMissingTranslationKeyToTrackJs;
